import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../../styles/checkout/mainStyle.css'

import {toggleDisplayIframe,setNotTerminateCheckout,setDisplayCheckout} from  '../../../actions/checkoutActions'

export class DisplayBrowser extends Component {
    state = {
        topRef: React.createRef(),
        firstCheck:true,
        showError:false,
        showSuccess:false,
        justClicked:false,  
    };

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    counter = 0

    constructor(props) {
        super(props); 
        this.startToDisplay =this.startToDisplay.bind(this)
    }

    startToDisplay() { 
        this.props.toggleDisplayIframe()
        this.props.setDisplayCheckout()
        this.props.setNotTerminateCheckout()
        this.setState({justClicked:true})
    }

    renderMessage() {
        if(this.state.showError) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#ffcccc', color:'#cc0000', padding:'1vw', borderRadius:'10px', border:'1px solid #ff8080', lineHeight: '3vh'}}><strong>Error!</strong><br />Please check your parameters within checkout request.</div>
            );
        }
        else if(this.state.showSuccess) {
            return (
                <div style={{ marginTop:'1vh', marginRight: '3vw',backgroundColor:'#d6f5d6', color:'#196719', padding:'1vw', borderRadius:'10px', border:'1px solid #6fdc6f', lineHeight: '3vh'}}><strong>Order ID Accepted!</strong><br />The returned Order ID has been inserted to the sample code, you can make a Receipt Request now.</div>
            );
        }
    }

    componentDidUpdate() {        
        if(this.props.callBackConsole.length ===2 && this.state.justClicked ){
            if(this.props.callBackConsole.length ===2) {               
                this.setState({ showError: false, firstCheck:false,showSuccess: true,justClicked:false });  
            }
            else {
                this.setState({  showError: true,firstCheck:false, showSuccess: false,justClicked:false });
        }
        }
        this.counter++
    }

    renderInteractiveTool(){
        const { ticket } = this.props;

        return (
            <div className = "stepMainContainer">
                <p style={{marginTop: '5vh'}}>When a customer goes to check out their items for purchase, the Moneris Checkout page is displayed in the &lt;div&gt; tag you created on your web site.</p>
                <p>To insert the Moneris Checkout instance into the &lt;div&gt;, you call the JavaScript function:</p>
                <pre><span id="code5">myCheckout.startCheckout("<span>{ticket}</span>") ;</span></pre>
                <div className="requestButton" onClick={() => this.startToDisplay()}>Display Checkout</div>
                {this.renderMessage()}
        </div>
        )
    }

    renderDocument(){
        const { ticket } = this.props;
        return (
            <div  className= "stepPageContainer">
                <h3 ref={this.state.topRef} className="stepPageTitle">Display in Browser</h3> 
                <p style={{marginTop: '3vh'}}>When a customer goes to check out their items for purchase, the Moneris Checkout page is displayed in the &lt;div&gt; tag you created on your web site.</p>
                <p>To insert the Moneris Checkout instance into the &lt;div&gt;, you call the JavaScript function:<br></br></p>
                <pre><span id="code5">myCheckout.startCheckout("{ticket}");</span></pre>
                {this.renderMessage()}
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
      }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const {ticket, ifTerminateCheckout, ifDisplayCheckout, callBackConsole } = state.checkout.main;
    return { mode, ticket, ifTerminateCheckout, ifDisplayCheckout, callBackConsole };
}

export default connect(mapStateToProps,{toggleDisplayIframe, setNotTerminateCheckout, setDisplayCheckout})(DisplayBrowser)


